export default __webpack_public_path__ + "static/media/pullman-phuket-arcadia-slider.eed27cac.jpg";